module.exports = __webpack_public_path__ + "fonts/vFMt2r20.woff2";